import { TransactionFiltersDTO } from "../models/Transaction";
import { UpdateValues } from "../validation/RegisterValidation";
import axiosInstance from "./axiosInstance";

const changePassword = async (data: {
  oldPassword: string;
  newPassword: string;
}) => {
  const response = await axiosInstance.patch("auth/update/password", data);

  return response.data;
};

const updateUser = async (user: Partial<UpdateValues>) => {
  const response = await axiosInstance.post("user/update", user);
  return response.data;
};

type CustomerQueryParams = {
  page?: number;
  limit?: number;
  search?: string;
  sortBy?: "createdAt" | "updatedAt" | "isActivate" | "isKycSubmitte";
  sortOrder?: "ASC" | "DESC";
  isActivate?: boolean;
  isEntreprise?: boolean;
  isKycSubmitte?: boolean;
  mode?: string;
  startDate?: string;
  endDate?: string;
};

const getAllCustomers = async (params?: CustomerQueryParams) => {
  const response = await axiosInstance.get("customer/all", { params });
  return response.data;
};

const getAllUsers = async (): Promise<any> => {
  const response = await axiosInstance.get("user");
  return response.data;
};

const deleteUser = async (id: string): Promise<any> => {
  const response = await axiosInstance.delete(`user/${id}`);
  return response.data;
};

const getStatisticsCustomer = async (startDate?: string, endDate?: string) => {
  const response = await axiosInstance.get(`customer/statistics`, {
    params: {
      startDate : startDate,
      endDate : endDate,
    },
  });
  return response.data;
}

const getCustomerById = async (id: string) => {
  const response = await axiosInstance.get(`customer/${id}`);
  return response.data;
};

const createWithdrawalRequest = async (data: { amount: number }) => {
  const response = await axiosInstance.post("withdrawals/create", data);
  return response.data;
};

type CreateUserPayload = {
  firstname: string;
  lastname?: string;
  email: string;
  password: string;
  phone: string;
  dateOfBirth?: Date;
  gender?: string;
  country: string;
  city?: string;
  address?: string;
  status?: string;
  isVerified?: boolean;
  roleCode?: string;
};

const createUser = async (data: CreateUserPayload): Promise<any> => {
  const response = await axiosInstance.post("user/create", data);
  return response.data;
};

type UpdateUserPayload = {
  firstname: string;
  lastname?: string;
  email: string;
  password?: string;
  phone: string;
  dateOfBirth?: Date;
  gender?: string;
  country: string;
  city?: string;
  address?: string;
  status?: string;
  isVerified?: boolean;
  roleCode?: string;
};

const updateUserById = async (
  id: string,
  data: UpdateUserPayload
): Promise<any> => {
  const response = await axiosInstance.post(`user/update/${id}`, data);
  return response.data;
};

const updateUserAdmin = async (data: any): Promise<any> => {
  const response = await axiosInstance.post(`user/update/${data.userId}`, data);
  return response.data;
};

const getAllWithdrawForCustomer = async (filters: TransactionFiltersDTO) => {
  const response = await axiosInstance.get("withdrawals/all", {
    params: {
      status: filters.status,
      startDate: filters.startDate,
      endDate: filters.endDate,
    },
  });
  return response.data;
};
const getAllWithdrawals = async (filters: TransactionFiltersDTO) => {
  const response = await axiosInstance.get("withdrawals/admin/all", {
    params: {
      status: filters.status,
      startDate: filters.startDate,
      endDate: filters.endDate,
    },
  });
  return response.data;
};

const getOneWithdrawal = async (withdrawalId: string) => {
  const response = await axiosInstance.get(`withdrawals/detail/${withdrawalId}`);
  return response.data;
};

const manageWithdrawal = async (
  action: 'approve' | 'reject',
  data: { withdrawId: string, adminNotes:string } 
) => {
  const response = await axiosInstance.post(`withdrawals/admin/manage/${action}`, data);
  return response.data;
};

interface CreateWebhookDto {
  url: string;
  events?: string[];
  isActive?: boolean;
}

interface UpdateWebhookDto {
  url?: string;
  events?: string[];
  isActive?: boolean;
}

interface FilterWebhooksDto {
  isActive?: boolean;
  event?: string;
}

const createWebhook = async (data: CreateWebhookDto) => {
  const response = await axiosInstance.post("webhooks", data);
  return response.data;
};

const getUserWebhooks = async () => {
  const response = await axiosInstance.get("webhooks");
  return response.data;
};

const updateWebhook = async (id: string, data: UpdateWebhookDto) => {
  const response = await axiosInstance.put(`webhooks/${id}`, data);
  return response.data;
};

const deleteWebhook = async (id: string) => {
  const response = await axiosInstance.delete(`webhooks/${id}`);
  return response.data;
};

const getAllWebhookEvents = async (): Promise<string[]> => {
  const response = await axiosInstance.get("webhooks/events/available");
  return response.data;
};

const validateCustomerKycByAdmin = async () => {
const response = await axiosInstance.patch('customer/admin/kyc/validate/')
}


export const UserService = {
  changePassword,
  updateUser,
  getAllCustomers,
  getAllUsers,
  createUser,
  updateUserById,
  updateUserAdmin,
  deleteUser,
  getStatisticsCustomer,
  getCustomerById,
  createWithdrawalRequest,
  getAllWithdrawForCustomer,
  getOneWithdrawal,
  getAllWithdrawals,
  manageWithdrawal,
  createWebhook,
  getUserWebhooks,
  updateWebhook,
  deleteWebhook,
  getAllWebhookEvents,
};
